module.exports = __webpack_public_path__ + "static/media/FNGLA_logo_cmyk_300_digital.3883d2b0.jpeg";